<template>

    <v-dialog
      v-bind="$attrs"
      v-on="$listeners"
      v-model="showDialog"
      :max-width="maxWidth">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text><div v-html="helperText"></div></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>

  import constants from '../constants/generic.js'

  export default {
    name: 'HelperDialog',
    inheritAttrs: false, 
    props: {
      helperText: { type: String },
      show: { type: Boolean },
    },
    emits: ["close"],
    data: function () {
      return {
        maxWidth: constants.PopUpMaxWidth,
      };
    },
    computed: {
      showDialog: {
        get() { return this.show; },
        set(value) { if (!value) this.$emit("close"); } 
      }
    }
  };
</script>

<style lang="scss" scoped>

</style>